import React, {Fragment} from 'react';
import download_svg from './static/img/icons/download.svg';
import feedback_img from './static/img/Feedback-img.jpg';
import InputMask from "react-input-mask";


function FeedbackSection(props) {
  return (
        <Fragment>
            <div className="download_section_mobile">
                <div className="download_mobile_inner_wrapper">
                    <h2>You can download the necessary documents:</h2>
                    <a href="#" download className="download_button">
                        <img src={download_svg} alt="" />
                        <p>DGÝTBB (ENTERPRISE ECOLOGICAL PASSPORT) boýunça taslamany işläp düzmek üçin “Sagdyn ülke” HK ýüzlenme haty</p>
                    </a>
                    <a href="#" download className="download_button">
                        <img src={download_svg} alt="" />
                        <p>EP boýunça taslamany işläp düzmek üçin “Sagdyn ülke” HK ýüzlenýän hat</p>
                    </a>
                    <a href="#" download className="download_button">
                        <img src={download_svg} alt="" />
                        <p>DGÝTBB Başlangyç maglumatlar</p>
                    </a>
                    <a href="#" download className="download_button">
                        <img src={download_svg} alt="" />
                        <p>EP Başlangyç maglumatlar</p>
                    </a>
                </div>
                
            </div>


            <div className={`feedback_section ${props.margin_top}`} style={{backgroundImage: `url('${feedback_img}')`}}>
                
                <div className="feedback_inner_wrapper">
                    <div className="download_section">
                        <h2>You can download the necessary documents:</h2>
                        <a href="#" download className="download_button">
                            <img src={download_svg} alt="" />
                            <p>DGÝTBB (ENTERPRISE ECOLOGICAL PASSPORT) boýunça taslamany işläp düzmek üçin “Sagdyn ülke” HK ýüzlenme haty</p>
                        </a>
                        <a href="#" download className="download_button">
                            <img src={download_svg} alt="" />
                            <p>EP boýunça taslamany işläp düzmek üçin “Sagdyn ülke” HK ýüzlenýän hat</p>
                        </a>
                        <a href="#" download className="download_button">
                            <img src={download_svg} alt="" />
                            <p>DGÝTBB Başlangyç maglumatlar</p>
                        </a>
                        <a href="#" download className="download_button">
                            <img src={download_svg} alt="" />
                            <p>EP Başlangyç maglumatlar</p>
                        </a>
                        
                    </div>
                    
                    <form className="feedback_form_section" action="" method="post" >
                        <h2>Contact us</h2>
                        <label htmlFor="name">Your Last name and first name</label>
                        <input type="text" name="name" id="name" />
                        <label htmlFor="email">Your e-mail address</label>
                        <input type="text" name="email" id="email" />
                        <label htmlFor="phone_number">Your phone number</label>
                        <InputMask mask={'+993 69999999'} maskPlaceholder='+993 6_______' alwaysShowMask={false} />
                        <label htmlFor="message">Your message</label>
                        <textarea name="message" id="message" cols="30" rows="10"></textarea>
                        <div className="file_input">
                            <img src="img/icons/Feedback-ico.svg" alt="" />
                            <label htmlFor="attached_file">Attach scanned documents</label>
                            <input type="file" name="attached_file" id="attached_file" />
                        </div>
                        <div className="send_button">
                            <button className="btn_animation active green" type="submit">Send</button>
                        </div>
                    </form>
                    
                </div>
            </div>

        </Fragment>
    )
}

export default FeedbackSection